var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "skill-content" },
    [
      _vm.hasSections
        ? _vm._l(_vm.localSections, function(section, sectionIndex) {
            return _c(
              "div",
              {
                key: `${section.name || "section"}-${sectionIndex}`,
                staticClass: "skill-section"
              },
              [
                _c(
                  "div",
                  {},
                  [
                    _c("section-title", {
                      attrs: {
                        "container-class": " mt-4 mb-4",
                        content: section.name,
                        icon: "fas fa-user text-orange",
                        reverse: ""
                      }
                    })
                  ],
                  1
                ),
                _vm._l(section.questions, function(question) {
                  return _c("skill-question-row", {
                    key: question.id,
                    attrs: {
                      answers: _vm.answers,
                      "is-read-only": _vm.isReadOnly,
                      question: question
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateQuestion(question, $event)
                      }
                    }
                  })
                })
              ],
              2
            )
          })
        : _vm._l(_vm.localQuestions, function(question) {
            return _c("skill-question-row", {
              key: question.id,
              attrs: {
                answers: _vm.answers,
                "is-read-only": _vm.isReadOnly,
                question: question
              },
              on: {
                input: function($event) {
                  return _vm.updateQuestion(question, $event)
                }
              }
            })
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }